

































































































import Component, { mixins } from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import { MyOptions } from "@/charts/graphData";
import MobileMixin from "@/mixins/mobileMixin";
import CaGraph from "@/homeGraph/CaGraph.vue";
import CaData from "@/homeGraph/CaData.vue";
import Top10 from "@/homeGraph/top10.vue";
import BKData from "@/homeGraph/BKData.vue";

@Component({
  components: {
    CaGraph,
    CaData,
    Top10,
    BKData,
  },
})
export default class HomeBk extends mixins(MyMixin, MobileMixin) {
  @Prop() public myOptions!: MyOptions;
  @Prop() public testChange!: MyOptions;
  @Prop() public isTTC!: boolean;

  public mounted() {
    // console.log(this.myOptions);
  }

  @Watch("myOptions", { immediate: true, deep: true })
  public onPropertyChanged(value: any, oldValue: any) {
    this.$forceUpdate();
  }

  public loaded() {
    this.$emit("loaded");
  }
}
